(function() {
'use strict';

angular
    .module('core')
    .directive('isolatedNestedForm', isolatedNestedForm);

function isolatedNestedForm() {
    return {
      restrict: 'A',
      require: '?form',
      link(scope, element, attrs, formController) {
        let isolatedFormEnabled = true;
        if (attrs.isolatedNestedFormEnabled !== undefined) {
          isolatedFormEnabled = (attrs.isolatedNestedFormEnabled === 'true');
        }
        if (!formController) {
          return;
        }
        const parentForm = formController.$$parentForm;
        if (!parentForm) {
          return;
        }
        // Remove this form from parent controller
        if (isolatedFormEnabled) {
          parentForm.$removeControl(formController);
        }
      }
    };
  }
})();
